export enum CategoryTypes {
    MEMBERSHIP,
    SERVICE,
    INTEGRATION,
}

export interface CategoryApiOutput {
    id: string
    name: string
    type: CategoryTypes
    imageUrl?: string
    deletedAt?: string
}

export type CategoryApiInput = Omit<CategoryApiOutput, 'id'>
export const CATEGORY_TYPES = {
    SERVICE: 'SERVICE',
    MEMBERSHIP: 'MEMBERSHIP',
    INTEGRATION: 'INTEGRATION',
}
